import { Checkbox } from "@chakra-ui/react";
import React, { FC } from "react";
import { FieldRenderProps } from "react-final-form";
import { DefaultFieldProps } from "../../types";

interface CheckboxFieldProps extends DefaultFieldProps {
  isDisabled?: boolean;
  isChecked?: boolean;
  size?: string | number;
  defaultChecked?: boolean;
}

const CheckboxField: FC<FieldRenderProps<CheckboxFieldProps & any>> = (
  props
) => {
  const {
    input,
    label,
    isDisabled,
    isChecked,
    size = "lg",
    defaultChecked,
  } = props;

  return (
    <Checkbox
      {...input}
      defaultChecked={defaultChecked}
      isChecked={isChecked}
      isDisabled={isDisabled}
      type="checkbox"
      colorScheme="whatsapp"
      size={size}
    >
      {label}
    </Checkbox>
  );
};

export default CheckboxField;
